"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _sendProductSearchRequest = _interopRequireDefault(require("@deosite/helpers/sendProductSearchRequest"));
var _sendCategorySearchRequest = _interopRequireDefault(require("@deosite/helpers/sendCategorySearchRequest"));
var _mapProductDataNew = _interopRequireDefault(require("@deosite/helpers/mapProductDataNew"));
var _mapCategory = _interopRequireDefault(require("@deosite/helpers/mapCategory"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var mapFilters = function mapFilters(filters) {
  return filters.map(function (item) {
    var newItem = _objectSpread(_objectSpread({}, item), {}, {
      label: item.name
    });
    if (item.items) {
      newItem.options = item.items.map(function (option) {
        return _objectSpread(_objectSpread({}, option), {}, {
          label: option.name,
          id: option.id + ""
        });
      });
    }
    if (item.type === "color") {
      newItem.type = "multiselect";
    }
    if (item.type === "select") {
      newItem.type = "multiselect";
    }
    if (item.id === "sort") {
      item.options = item.options.filter(function (option) {
        return option.id !== "position-desc";
      });
    }
    return newItem;
  });
};
var fetcher = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(_ref) {
    var _categories$items;
    var phrase, language, pickedFilters, _ref$currentPage, currentPage, _ref$pageSize, pageSize, _ref$initialFilters, initialFilters, _ref$isQuickSearch, isQuickSearch, _yield$Promise$all, _yield$Promise$all2, result, categories, defaultFilters, filters;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            phrase = _ref.phrase, language = _ref.language, pickedFilters = _ref.pickedFilters, _ref$currentPage = _ref.currentPage, currentPage = _ref$currentPage === void 0 ? 1 : _ref$currentPage, _ref$pageSize = _ref.pageSize, pageSize = _ref$pageSize === void 0 ? global.__appConfig__.categoryPageSizeLargerRange : _ref$pageSize, _ref$initialFilters = _ref.initialFilters, initialFilters = _ref$initialFilters === void 0 ? null : _ref$initialFilters, _ref$isQuickSearch = _ref.isQuickSearch, isQuickSearch = _ref$isQuickSearch === void 0 ? false : _ref$isQuickSearch;
            _context.next = 3;
            return Promise.all([(0, _sendProductSearchRequest["default"])({
              query: phrase,
              currentPage: currentPage,
              pageSize: pageSize,
              lang: language,
              pickedFilters: pickedFilters
            }), (0, _sendCategorySearchRequest["default"])({
              query: phrase,
              lang: language
            })]);
          case 3:
            _yield$Promise$all = _context.sent;
            _yield$Promise$all2 = (0, _slicedToArray2["default"])(_yield$Promise$all, 2);
            result = _yield$Promise$all2[0];
            categories = _yield$Promise$all2[1];
            defaultFilters = result.filters.items; // if (!initialFilters && !isQuickSearch) {
            //   defaultFilters = await sendProductSearchRequest({
            //     query: phrase,
            //     currentPage: 1,
            //     pageSize,
            //     lang: language,
            //     pickedFilters: {}
            //   });
            //   defaultFilters = defaultFilters?.filters?.items;
            // }
            filters = result.filters.items ? mapFilters(result.filters.items) : [];
            if (filters && pickedFilters) {
              if (pickedFilters["sort"]) {
                filters.push({
                  id: "sort",
                  value: pickedFilters["sort"]
                });
              }
              filters.forEach(function (filter) {
                if (pickedFilters[filter.id]) {
                  if (filter.type === "multiselect") {
                    filter.value = pickedFilters[filter.id];
                  }
                }
                if (pickedFilters[filter.id]) {
                  if (filter.type === "range") {
                    var initialFilter = defaultFilters === null || defaultFilters === void 0 ? void 0 : defaultFilters.find(function (initialFilter) {
                      return initialFilter.id === filter.id;
                    });
                    if (initialFilter) {
                      filter.min = initialFilter.min;
                      filter.max = initialFilter.max;
                    }
                    filter.value = pickedFilters[filter.id];
                  }
                }
              });
            }
            return _context.abrupt("return", {
              categories: (_categories$items = categories.items) === null || _categories$items === void 0 ? void 0 : _categories$items.map(_mapCategory["default"]).filter(function (category) {
                return category !== undefined;
              }),
              results: (0, _mapProductDataNew["default"])(result.items),
              totalCount: result.total_count,
              filters: filters,
              defaultFilters: defaultFilters
            });
          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function fetcher(_x) {
    return _ref2.apply(this, arguments);
  };
}();
var _default = fetcher;
exports["default"] = _default;